// ProtectedRoute.jsx
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const { admin, token } = useContext(AuthContext);
  
  // ✅ FIXED: Look for the correct admin-specific token key
  const savedToken = localStorage.getItem("admin_access_token");

  // ✅ ENHANCED: Check that both the token AND the admin object exist
  if (!admin || (!token && !savedToken)) {
    return <Navigate to="/login" replace />;
  }

  return children;
}